import api from './';
import { normalizePaymentMethods } from '@/helpers/normalizers';

export default {
  fetchAll: () => api.get('payment_methods').json().then(response => normalizePaymentMethods(response.data)),
  delete: (id) => api.delete(`payment_methods/${id}`),
};
